import { Component, OnInit, Injectable, } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { SBHttpServicesService } from '../../../shared/services/sbhttp-services.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserInfo } from '../../../userInfo';

import { SignalRHelperService } from '../../../shared/services/SignalRHelper.service';
import { NotificationService } from 'BI-Libraries/BI-Components/projects/bi-modules/src/lib/services/notification.service';
import { GetNotificationsOptions } from './notificationOptions';
import { TranslateService } from '@ngx-translate/core';

const browserType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 1 : 0;
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

    public noticationNumber: number = 0;
    public tasksNumber: number = 0;
    public URL: any = 'api/Supervisor/RequestNotificationNumber/';
    public TasksURL: any = 'api/Supervisor/GetWorkflowTasksCount/';
    public DetailsURL: any = 'api/Supervisor/GetAllNotification/';
    public AdvancedWorkFlow: any;
    public AllNotifi: any[];
    public PrevNotification;
    public NotificationOptionMap;
    constructor(
        private environment: AppConfigService,
        private httpService: SBHttpServicesService,
        private _router: Router,
        
        
        private _signalrService: SignalRHelperService,
        private NotifiService: NotificationService,
        public translateService: TranslateService) {
        this.NotificationOptionMap = GetNotificationsOptions(this._router)
    }

    async ngOnInit() {
        //
        this.NotifiService.requestNotificationPermission();
        //this.AdvancedWorkFlow = await this.Shared.getParamByID(7857);
        await this.getNotificationDetails();
        this._signalrService.refreshNotifications.subscribe((Notifications: any) => {
            this.updateNotificationCount(Notifications);
            var newNotif =  this.getUpdatedNotifications(this.PrevNotification, Notifications);
            this.notifiUser(newNotif);
            this.PrevNotification = Notifications;
            this.AllNotifi = Notifications.filter((x: any) => x.notCount > 0);;
        });

    }

    async getNotificationDetails() {
        let User = JSON.parse(localStorage.getItem("userinfo"));
        let UserCode = User['UserCode'];
        if(UserCode){
        var url = this.environment.oDataApi + `/api/Notifications/GetNotification/${UserCode}`;
        var data = await this.httpService.httpGetRequest(url, "", false);
        if (data) {
            if (!data) this.AllNotifi = [];
            else {
                this.AllNotifi = data.filter((x: any) => x.notCount > 0);
                this.PrevNotification = data;
               this.updateNotificationCount(this.AllNotifi);
            }
        }
    }
    }

   

    async NotificationDetails() {
        // var url = this.environment.apiRoot + this.DetailsURL + UserInfo.BrowserType;
        // var data = await this.httpService.httpGetRequest(url, "", false);
        // if (data) {
        //     if (!data['data']) this.AllNotifi = [];
        //     else this.AllNotifi = data['data'];
        // }
    }
    async callTasksAPI() {
        // var url = this.environment.apiRoot + this.TasksURL;
        // var data = await this.httpService.httpGetRequest(url, "", false);
        // if (data)
        //     if (isNaN(data['data'])) this.tasksNumber = 0;
        //     else this.tasksNumber = parseInt(data['data']);
    }

    GoToScreen(type: string, route: any) {
        if(browserType == 1 && route == "SupervisorBeta/Exceptions"){
            route = "SupervisorBeta/ExceptionsMobile";
        }
        this._router.navigate([route]);
    }

    getUpdatedNotifications(oldNotifications: [any], newNotifications: [any]) {
        let res = [];
        newNotifications.forEach(newNotifi => {
            let oldNotifi = oldNotifications.find(n => n.screenName === newNotifi.screenName);
            if (newNotifi.notCount > oldNotifi.notCount)
                res.push(newNotifi);
        })
        return res;
    }

    notifiUser(notification: any[]) {
        notification.forEach(n => {
            var notificationOption = this.NotificationOptionMap.get(n.screenName);
            let option = {... notificationOption};
            option.Body += ` ${n.notCount}`;
            this.NotifiService.notifyMe(option);
        })
    }

    updateNotificationCount(notification :any[]){
        this.noticationNumber = 0;
        notification.forEach((x: any) => { this.noticationNumber += x.notCount });
    }

    GetNotficIcon(screenName: string){
        return this.NotificationOptionMap.get(screenName).Icon;
    }


}
